<template>
  <div>
    <v-container>
      <v-row>
        <v-col v-if="!hasPages" cols="12" class="text-center pb-0">
            <h3>You Dont Have Pages Saved.</h3>
            <p>Please select a page below. These are pages you have a role on.</p>
            <facebookLiveInfoCapture 
                :pages="pages" 
                :adsAccountsForPage="adsAccountsForPage" 
                @reloadUsersPages="reloadUsersPages" 
                :hasPages="hasPages"
                :docId="this.docId"
            />
        </v-col>
      </v-row>
      <v-row v-if="hasPages" justify="center" align="center">
        <v-col cols="3">
            <v-select
                v-model="page"
                :items="usersPages"
                item-text="pageName"
                item-value="pageId"
                label="Select Page"
                @change="loadDifferentPages(page)"
              >
             </v-select>
        </v-col>
        <v-col cols="6" class="text-center"> 
            <h2 class="compeatfont">Facebook Live</h2>    
        </v-col>
        <v-col cols="3" class="text-right">
            <facebookLiveInfoCapture 
                :pages="pages" 
                :adsAccountsForPage="adsAccountsForPage"
                @reloadUsersPages="reloadUsersPages" 
                :hasPages="hasPages"
                :docId="this.docId"
            />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import facebookLiveInfoCapture from "../components/dialogs/facebookLiveInfoCapture.vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebaseApp } from "../firebaseConfig";
import { collection, query, where, getDocs, getFirestore } from "firebase/firestore";
const db = getFirestore(firebaseApp);
export default {
  components:{
    facebookLiveInfoCapture
  },  
  data: () => ({
    docId:'',
    usersPagesDoc:[],
    usersPages:[],
    pages: [],
    page:{},
    hasPages:false,
    // page: null,
    // adAccountId: "",
    adsAccountsForPage: [],
    // fbToken: "",
    // pageId: "",
    facebookData: [],
  }),
  created() {
    this.getUserPages();
  },
  methods: {
    async getUserPages(){
        const q = query(collection(db, "usersPages"), where("userId", "==", this.$store.state.user.id));

        const querySnapshot = await getDocs(q);
        querySnapshot.forEach((doc) => {
            if(doc.data()){
            this.usersPagesDoc = doc.data()
            this.usersPages = this.usersPagesDoc.pages
            this.docId =  this.usersPagesDoc.uid   
            this.hasPages = true
            this.primaryPage = this.usersPagesDoc.pages[0]
            this.page = this.primaryPage
            this.getData(this.primaryPage)
            console.log('Does have pages')
        }else {
            this.hasPages = false
            this.docId =  ""
            console.log('Doesnt have pages')
        }
        });

        this.checkUsersPages()
    },
    checkUsersPages() {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const getPagesForUsers = httpsCallable(functions, "getPagesForUsers");

        getPagesForUsers({
          userToken: this.$store.state.user.facebookToken,
        }).then((result) => {
          this.pages = result.data.response.data;
          console.log('this.pages', this.pages)
          this.getAdsAccountsForPage()
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    //Gets ads account for the current logged in user from facebook
    getAdsAccountsForPage() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const getAdAccountId = httpsCallable(functions, "getAdAccountId");

      getAdAccountId({
        userToken: this.$store.state.user.facebookToken,
      }).then((result) => {
        console.log("getAdsAccountsForPage result", result);
        let array = result.data.response;

        let emptyItem = {
          name: "No Ad Account For Page",
          id: "0",
          account_id: "",
        };

        array.unshift(emptyItem);

        this.adsAccountsForPage = array;
        setTimeout(() => {
          this.checkingForAccess = false;
          this.hasAccess = true;
          this.$store.commit("setHasAccess", this.hasAccess);
          this.overlay = false;
        }, 2000);
      });
    },
    //Gets Facebook live report data
    getData(data) {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const facebookLiveDataSimon = httpsCallable(
          functions,
          "facebookLiveDataSimon"
        );

        facebookLiveDataSimon({
          fbToken: data.pageToken,
          pageId: data.pageId,
          timeLine: 90,
          userToken:this.$store.state.user.facebookToken,
          adsAccountId:data.adsAccountId
          //   since: this.since,
          //   until: this.until,
        }).then((result) => {
          this.facebookData = result.data.response;
          console.log("Audience", this.facebookData.audience.audience);
          console.log("engagement", this.facebookData.engagement.engagment);
          console.log("posts", this.facebookData.posts.posts);
          console.log("reach", this.facebookData.reach.reach);
          console.log("video", this.facebookData.video.video);
          //   this.reach = this.facebookData.reach;
          //   this.links = this.facebookData.linkClick;
          //   this.follows = this.facebookData.follows;
          //   this.postsContent = this.facebookData.content;
          //   this.getReachData();
          console.log("this.facebookData", this.facebookData);
        });
      } catch (err) {
        console.log("err", err);
      }
    },
    //Creates a doc for the users if its the first time using the live report
    reloadUsersPages(data){
        if (data == true) {
            this.getUserPages()
        }
    },
    loadDifferentPages(item) {
      console.log("item", item);
        // this.getData(item)
        this.usersPages.forEach((account) => {
            console.log(account)
        if (account.pageId === item) {
            // this.primaryPage = account
            console.log(item)
            this.primaryPage = account
            this.getData(this.primaryPage)
        }
      });
    },
  },
};
</script>
